export default __webpack_public_path__ + "2667ab98a17a32a720e5d22d673d7b42.png";